import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const moveScheduleCommentaryCategory = api(async function moveScheduleCommentaryCategory({ id, category }) {
    return mutate(
        gql`
            mutation MoveScheduleCommentaryCategory($id: String!, $category: String!) {
                moveScheduleCommentaryCategory(id: $id, category: $category)
            }
        `,
        { id, category },
        { returns: "moveScheduleCommentaryCategory" }
    )
})
